import { AxiosError, AxiosResponse } from 'axios';

/**
 * Axios resolves a response that has no status code, see `settle`: `!response.status || ...`.
 * The browser reports status 0 when a request was terminated instead of answered
 * (connection dropped, request blocked, page unloaded), and such a "response" has an empty body.
 * Without this interceptor callers receive an empty string instead of the expected payload
 * and crash later on unexpected `data` object type e.g. `query.data.map(...)` where data will be unexpectedly string.
 * Treat a response without a status code as a network error.
 */
export function noStatusInterceptor(response: AxiosResponse) {
  if (!response?.status) {
    throw new AxiosError(
      'Request failed without a status code',
      AxiosError.ERR_NETWORK,
      response?.config,
      response?.request,
      response,
    );
  }

  return response;
}
